// ==========  NOTIFICATION  ============

const NOT_FOUND =
  'Sorry, no data matching your search query. Please try again with different search parameters.';

// ==========  DATE FORMAT  ============

const AGES_IN_WORDS = {
  '0 years': 'less than a year',
  '1 year': 'one year',
  '2 years': 'two years',
  '3 years': 'three years',
  '4 years': 'four years',
  '5 years': 'five years',
  'more 5 years': 'more than five years',
};

// ==========  AUTHORIZED  ============

const MUST_AUTHORIZED = 'You must be authorized to use this functionality!';
const MUST_AUTHORIZED_QUESTION = 'Do you want to go to Login Form?';

const MUST_AUTHORIZED_TO_FAVORITES = 'Sign in or register to add to favorites.';

// ==========  QUESTION  ============

const CONFIRMATION_DELETE = 'Are you sure you want to remove this ad?';

// ==========  FETCH NOTICES  ============

const DEFAULT_LIMIT = 0;

// ==========  CATEGORIES NOTICES  ============

const CATEGORIES_NOTICES = {
  'sell': 'sell',
  'lost-found': 'lost/found',
  'in-good-hands': 'in good hands',
};

// ==========  ============  ============

export {
  NOT_FOUND,
  AGES_IN_WORDS,
  MUST_AUTHORIZED,
  MUST_AUTHORIZED_QUESTION,
  MUST_AUTHORIZED_TO_FAVORITES,
  DEFAULT_LIMIT,
  CONFIRMATION_DELETE,
  CATEGORIES_NOTICES
};
